import axios from "axios";
import { basicURL, aiQuizCopilotURL, aiMcpToolsURL, aiMcpInvokeURL } from "../../apiManager/APIConfig";
import { store } from "../store";

function resolveAuthHeader() {
  const access_token = store.getState().auth?.access_token;
  if (!access_token) return null;
  return access_token.startsWith("Bearer ") ? access_token : `Bearer ${access_token}`;
}

async function postJson(path, body) {
  const authHeader = resolveAuthHeader();
  if (!authHeader) {
    return { status: 401, message: "Please sign in again to use Quiz Copilot." };
  }
  try {
    const response = await axios.post(`${basicURL}${path}`, body, {
      headers: { Authorization: authHeader, "Content-Type": "application/json" },
      timeout: 120000,
    });
    return response?.data;
  } catch (err) {
    if (err?.response?.data) return err.response.data;
    return {
      status: err?.response?.status || 0,
      message: err?.message || "Network error contacting Quiz Copilot.",
    };
  }
}

async function getJson(path) {
  const authHeader = resolveAuthHeader();
  if (!authHeader) {
    return { status: 401, message: "Please sign in again to use Quiz Copilot." };
  }
  try {
    const response = await axios.get(`${basicURL}${path}`, {
      headers: { Authorization: authHeader },
      timeout: 60000,
    });
    return response?.data;
  } catch (err) {
    if (err?.response?.data) return err.response.data;
    return {
      status: err?.response?.status || 0,
      message: err?.message || "Network error contacting Quiz Copilot.",
    };
  }
}

export const listMcpToolsCall = () => getJson(aiMcpToolsURL);

export const invokeMcpToolCall = ({ tool, args = {}, draft = null, confirm_create = false, client_request_id = null }) =>
  postJson(aiMcpInvokeURL, {
    tool,
    arguments: args,
    draft,
    confirm_create,
    client_request_id,
  });

export const quizCopilotChatCall = ({
  message,
  draft,
  confirm_create = false,
  client_request_id = null,
  dashboard = null,
  history = [],
  source_id = null,
}) =>
  postJson(aiQuizCopilotURL, {
    message,
    draft,
    confirm_create,
    client_request_id,
    dashboard,
    history,
    source_id,
  });

export const uploadAssistantSourceCall = async (file) => {
  const authHeader = resolveAuthHeader();
  if (!authHeader) {
    return { status: 401, message: "Please sign in again to use the AI assistant." };
  }
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(`${basicURL}ai/assistant-source`, formData, {
      headers: { Authorization: authHeader },
      timeout: 180000,
    });
    return response?.data;
  } catch (err) {
    const status = err?.response?.status || 0;
    const data = err?.response?.data;
    if (data && typeof data === "object") {
      return {
        status: data.status || status,
        message: data.message || "Upload failed.",
      };
    }
    if (status === 502 || status === 504) {
      return {
        status,
        message: "The server timed out while reading that file. Try a smaller file, or save the PowerPoint as .pptx.",
      };
    }
    return {
      status,
      message: err?.message || "Upload failed.",
    };
  }
};
